// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 9ca3sE4gAMHXGHWcmrUodR
// Component: KQlZmB74u86
import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import ListElement from "../../ListElement"; // plasmic-import: gZQS8RDUPA/component

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic_main.module.css"; // plasmic-import: 9ca3sE4gAMHXGHWcmrUodR/projectcss
import sty from "./PlasmicLevelsMenu.module.css"; // plasmic-import: KQlZmB74u86/css

import XSvgrepoComsvgIcon from "./icons/PlasmicIcon__XSvgrepoComsvg"; // plasmic-import: bhCqgTTbQ_/icon

export type PlasmicLevelsMenu__VariantMembers = {
  state: "levels" | "spaces";
  empty: "empty";
};

export type PlasmicLevelsMenu__VariantsArgs = {
  state?: MultiChoiceArg<"levels" | "spaces">;
  empty?: SingleBooleanChoiceArg<"empty">;
};

type VariantPropType = keyof PlasmicLevelsMenu__VariantsArgs;
export const PlasmicLevelsMenu__VariantProps = new Array<VariantPropType>(
  "state",
  "empty"
);

export type PlasmicLevelsMenu__ArgsType = {
  storiesList?: React.ReactNode;
};

type ArgPropType = keyof PlasmicLevelsMenu__ArgsType;
export const PlasmicLevelsMenu__ArgProps = new Array<ArgPropType>(
  "storiesList"
);

export type PlasmicLevelsMenu__OverridesType = {
  root?: p.Flex<"div">;
  closeHandle?: p.Flex<"div">;
  svg?: p.Flex<"svg">;
  storiesList?: p.Flex<"div">;
};

export interface DefaultLevelsMenuProps {
  storiesList?: React.ReactNode;
  state?: MultiChoiceArg<"levels" | "spaces">;
  empty?: SingleBooleanChoiceArg<"empty">;
  className?: string;
}

function PlasmicLevelsMenu__RenderFunc(props: {
  variants: PlasmicLevelsMenu__VariantsArgs;
  args: PlasmicLevelsMenu__ArgsType;
  overrides: PlasmicLevelsMenu__OverridesType;

  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const $ctx = ph.useDataEnv?.() || {};
  const args = React.useMemo(
    () =>
      Object.assign(
        {},

        props.args
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const currentUser = p.useCurrentUser?.() || {};

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox__wyXnq)}>
        <div className={classNames(projectcss.all, sty.freeBox__daD7A)}>
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text___3F1F6,
              {
                [sty.textempty___3F1F68Noon]: hasVariant(
                  variants,
                  "empty",
                  "empty"
                ),
                [sty.textstate_spaces___3F1F6FuY34]: hasVariant(
                  variants,
                  "state",
                  "spaces"
                )
              }
            )}
          >
            {hasVariant(variants, "state", "spaces") ? "Rooms" : "Show stories"}
          </div>

          <p.Stack
            as={"div"}
            data-plasmic-name={"closeHandle"}
            data-plasmic-override={overrides.closeHandle}
            hasGap={true}
            className={classNames(projectcss.all, sty.closeHandle)}
          >
            <XSvgrepoComsvgIcon
              data-plasmic-name={"svg"}
              data-plasmic-override={overrides.svg}
              className={classNames(projectcss.all, sty.svg)}
              role={"img"}
            />
          </p.Stack>
        </div>

        {(hasVariant(variants, "empty", "empty") ? true : true) ? (
          <p.Stack
            as={"div"}
            data-plasmic-name={"storiesList"}
            data-plasmic-override={overrides.storiesList}
            hasGap={true}
            className={classNames(projectcss.all, sty.storiesList, {
              [sty.storiesListempty]: hasVariant(variants, "empty", "empty")
            })}
          >
            {p.renderPlasmicSlot({
              defaultContents: (
                <React.Fragment>
                  {true ? (
                    <ListElement
                      className={classNames(
                        "__wab_instance",
                        sty.listElement__nl43
                      )}
                    />
                  ) : null}
                  {true ? (
                    <ListElement
                      className={classNames(
                        "__wab_instance",
                        sty.listElement__lyPc4
                      )}
                    />
                  ) : null}
                  {true ? (
                    <ListElement
                      className={classNames(
                        "__wab_instance",
                        sty.listElement___0Cp2
                      )}
                    />
                  ) : null}
                  {true ? (
                    <ListElement
                      className={classNames(
                        "__wab_instance",
                        sty.listElement___3AZfk
                      )}
                    />
                  ) : null}
                  {true ? (
                    <ListElement
                      className={classNames(
                        "__wab_instance",
                        sty.listElement__w2IYd
                      )}
                    />
                  ) : null}
                </React.Fragment>
              ),
              value: args.storiesList
            })}
          </p.Stack>
        ) : null}
        {(hasVariant(variants, "empty", "empty") ? true : true) ? (
          <div
            className={classNames(projectcss.all, sty.freeBox___4FOmp, {
              [sty.freeBoxempty___4FOmp8Noon]: hasVariant(
                variants,
                "empty",
                "empty"
              )
            })}
          >
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__l6PEa,
                {
                  [sty.textempty__l6PEa8Noon]: hasVariant(
                    variants,
                    "empty",
                    "empty"
                  )
                }
              )}
            >
              {hasVariant(variants, "empty", "empty")
                ? "Nothing found"
                : "Keine Stockwerke gefunen"}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "closeHandle", "svg", "storiesList"],
  closeHandle: ["closeHandle", "svg"],
  svg: ["svg"],
  storiesList: ["storiesList"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  typeof PlasmicDescendants[T][number];
type NodeDefaultElementType = {
  root: "div";
  closeHandle: "div";
  svg: "svg";
  storiesList: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicLevelsMenu__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicLevelsMenu__VariantsArgs;
    args?: PlasmicLevelsMenu__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicLevelsMenu__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicLevelsMenu__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicLevelsMenu__ArgProps,
          internalVariantPropNames: PlasmicLevelsMenu__VariantProps
        }),
      [props, nodeName]
    );

    return PlasmicLevelsMenu__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicLevelsMenu";
  } else {
    func.displayName = `PlasmicLevelsMenu.${nodeName}`;
  }
  return func;
}

export const PlasmicLevelsMenu = Object.assign(
  // Top-level PlasmicLevelsMenu renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    closeHandle: makeNodeComponent("closeHandle"),
    svg: makeNodeComponent("svg"),
    storiesList: makeNodeComponent("storiesList"),

    // Metadata about props expected for PlasmicLevelsMenu
    internalVariantProps: PlasmicLevelsMenu__VariantProps,
    internalArgProps: PlasmicLevelsMenu__ArgProps
  }
);

export default PlasmicLevelsMenu;
/* prettier-ignore-end */
